<div class="collapse navbar-collapse justify-content-end" id="navigation">
    <p-dropdown [options]="languages" [(ngModel)]="selectedLanguage"
                (onChange)="changeLanguage($event)"></p-dropdown>
</div>
<form>
    <div class="group">
        <input type="text" (click)="loginError = false;" [(ngModel)]="email" [ngClass]="{'used': email.trim().length !== 0}"><span
            class="highlight"></span><span class="bar"></span>
        <label>{{ 'LOGIN.USERNAME_LABEL' | translate }}</label>
    </div>
    <div class="group">
        <input type="password" (click)="loginError = false;" [(ngModel)]="password" [ngClass]="{'used': password.trim().length !== 0}"><span class="
               highlight"></span><span class="bar"></span>
        <label>{{ 'LOGIN.PASSWORD_LABEL' | translate }}</label>
        <span class="loginError" *ngIf="loginError">{{ 'LOGIN.LOGIN_ERROR' | translate }}</span>
    </div>
    <button type="button" class="button loginButton" (click)="login()">{{ 'LOGIN.LOGIN_BUTTON' | translate }}
        <div class="ripples buttonRipples"><span class="ripplesCircle"></span></div>
    </button>
</form>
<footer>
    <a href="https://qrco.de/njoy_app" target="_blank"><img
            src="assets/icons/shared/njoy-logo.png"></a>
</footer>
